var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scaffold',{attrs:{"title":"Tour Chat","showBackButton":"","isFullWidth":""}},[(_vm.tour && _vm.user)?_c('chat-container',{attrs:{"user":_vm.user,"currentTour":_vm.tour,"messages":_vm.messages}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }